import agent from '../agent'
import {
  COMMENTS_LIST_LOADED,
  COMMENTS_LIST_UNLOADED,
  ADD_COMMENT_TO_COMMENTS_LIST,
    TOPIC_STANCE_COMMENTS_LIST_LOADED,
    TOPIC_STANCE_ADD_COMMENT_TO_COMMENTS_LIST
} from "../constants/actionTypes"

export const commentsListLoaded = (payload) => ({
  type: COMMENTS_LIST_LOADED,
  payload
})

export const topicStanceCommentsListLoaded = (payload) => ({
  type: TOPIC_STANCE_COMMENTS_LIST_LOADED,
  payload
})

export const commentsListUnloaded = () => ({
  type: COMMENTS_LIST_UNLOADED
})

export const loadCommentsList = (dispatch) => (postIds) => {
  agent.Comments.getcommentsList(postIds).then(res => {
    dispatch(commentsListLoaded(res));
  }, err => {
    dispatch(commentsListLoaded({
      hasError: true,
      error: err?.response?.body?.responseStatus?.message || []
    }));
  })
}

export const loadTopicStanceCommentsList = (dispatch) => (topicStancesIds) => {
  agent.Comments.getTopicStancecommentsList(topicStancesIds).then(res => {
    dispatch(topicStanceCommentsListLoaded(res));
  }, err => {
    dispatch(topicStanceCommentsListLoaded({
      hasError: true,
      error: err?.response?.body?.responseStatus?.message || []
    }));
  })
}

export const addCommentDispatch = (payload) => ({
  type: ADD_COMMENT_TO_COMMENTS_LIST,
  payload
})

export const topicStanceAddCommentDispatch = (payload) => ({
  type: TOPIC_STANCE_ADD_COMMENT_TO_COMMENTS_LIST,
  payload
})

export const addCommentToCommentsList = (dispatch, getState) => (comment) => {
  let store = getState();
  let commentsList = store.commentsList.list
    let newCommentList = [...commentsList, comment]
  dispatch(addCommentDispatch(newCommentList));
}

export const topicStanceCommentToCommentList = (dispatch, getState) => (comment) => {
  let store = getState();
  let commentsList = store.commentsList.topicStanceList
    let newCommentList = [...commentsList, comment]
  dispatch(topicStanceAddCommentDispatch(newCommentList));
}

export const deleteCommentToCommentsList = (dispatch, getState) => (id) => {
  let store = getState();
  let commentsList = store.commentsList.list
  let newCommentList= commentsList.filter(i => i.id !== id)
  dispatch(addCommentDispatch(newCommentList));
}

export const topicStanceDeleteCommentToCommentsList = (dispatch, getState) => (id) => {
  let store = getState();
  let commentsList = store.commentsList.topicStanceList
  let newCommentList= commentsList.filter(i => i.id !== id)
  dispatch(topicStanceAddCommentDispatch(newCommentList));
}

export const replaceCommentToCommentsList = (dispatch, getState) => (newComment) => {
    let store = getState();
    let commentsList = store.commentsList.list
    commentsList = commentsList.map(comment=> {
      if (comment?.id  === newComment?.id) {
          return newComment
      }
      return comment
    })
    dispatch(addCommentDispatch(commentsList));
}

export const topicStanceReplaceCommentToCommentsList = (dispatch, getState) => (newComment) => {
    let store = getState();
    let commentsList = store.commentsList.topicStanceList
    commentsList = commentsList.map(comment=> {
      if (comment?.id  === newComment?.id) {
          return newComment
      }
      return comment
    })
    dispatch(topicStanceAddCommentDispatch(commentsList));
}

export const unloadCommentsList = (dispatch) => () => {
  dispatch(commentsListUnloaded());
}

